(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, function() {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 480:
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ChainParameter = void 0;

var ChainParameter =
/** @class */
function () {
  function ChainParameter() {}

  return ChainParameter;
}();

exports.ChainParameter = ChainParameter;

/***/ }),

/***/ 860:
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ContractRequest = void 0;

var ContractRequest =
/** @class */
function () {
  function ContractRequest(name, method, role, confirmCallback, rejectCallback, errorCallback) {
    this.name = name;
    this.method = method;
    this.role = role;
    this.confirmCallback = confirmCallback;
    this.rejectCallback = rejectCallback;
    this.errorCallback = errorCallback;
  }
  /**
   * 合約名稱
   */


  ContractRequest.prototype.getName = function () {
    return this.name;
  };
  /**
   * 合約內的方法名稱
   */


  ContractRequest.prototype.getMethod = function () {
    return this.method;
  };
  /**
   * 合約內的Web3使用者(Sender|Receiver)
   */


  ContractRequest.prototype.getRole = function () {
    return this.role;
  };
  /**
   * 實作合約的方法
   * @param contract
   */


  ContractRequest.prototype.send = function (contract) {
    console.debug("Implements the contract ".concat(this.name, ".").concat(this.method, " by ").concat(contract));
  };
  /**
   * 處理方法的回應
   * @param err
   * @param data
   * @protected
   */


  ContractRequest.prototype.handleResponse = function (err, data) {
    if (err) {
      return;
    }

    if (this.confirmCallback) {
      this.confirmCallback(data);
    }

    console.log("Request ".concat(this.name, " with method ").concat(this.method, " is success. Data is ").concat(data));
  };
  /**
   * 處理錯誤的回應
   * @param err
   * @protected
   */


  ContractRequest.prototype.handleError = function (err) {
    if (err.code == ContractRequest.CODE_USER_REJECTED_REQUEST) {
      if (this.rejectCallback) this.rejectCallback();
      return;
    }

    if (this.errorCallback) {
      this.errorCallback(err);
    }
  };

  ContractRequest.CODE_USER_REJECTED_REQUEST = 4001;
  return ContractRequest;
}();

exports.ContractRequest = ContractRequest;

/***/ }),

/***/ 414:
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.EventData = void 0;

var EventData =
/** @class */
function () {
  function EventData(contractName, method) {
    this.contractName = contractName;
    this.method = method;
  }

  return EventData;
}();

exports.EventData = EventData;

/***/ }),

/***/ 895:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.EventRecovery = void 0;

var EventData_1 = __webpack_require__(414);

var EventRecovery =
/** @class */
function () {
  function EventRecovery(sender) {
    this.sender = sender;
    this.eventList = new Array();
  }

  EventRecovery.prototype.registerEvent = function (contractName, method) {
    for (var idx = 0; idx < this.eventList.length; idx++) {
      var eventData_1 = this.eventList[idx];

      if (eventData_1.contractName == contractName && eventData_1.method == method) {
        return;
      }
    }

    var eventData = new EventData_1.EventData(contractName, method);
    this.eventList.push(eventData);
  };

  EventRecovery.prototype.recover = function (callback) {
    if (!this.blockNumber) return;
    var option = {
      fromBlock: this.blockNumber,
      toBlock: 'latest'
    };

    for (var idx = 0; idx < this.eventList.length; idx++) {
      var eventData = this.eventList[idx];
      this.sender.getPastEvents(eventData.contractName, eventData.method, option, callback);
    }

    this.blockNumber = undefined;
  };

  EventRecovery.prototype.hold = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this;
            return [4
            /*yield*/
            , this.sender.getBlockNumber()];

          case 1:
            _a.blockNumber = _b.sent();
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return EventRecovery;
}();

exports.EventRecovery = EventRecovery;

/***/ }),

/***/ 676:
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));

/***/ }),

/***/ 556:
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Web3Role = exports.ReceiverErrorCode = exports.Web3Event = void 0;

var Web3Event =
/** @class */
function () {
  function Web3Event() {}

  Web3Event.DETECT_PROVIDER = 'DETECT_PROVIDER';
  Web3Event.CHANGE_CHAIN = 'CHANGE_CHAIN';
  Web3Event.CHANGE_ACCOUNT = 'CHANGE_ACCOUNT';
  Web3Event.ERROR_REQUESTED_ACCOUNT = 'ERROR_REQUESTED_ACCOUNT';
  Web3Event.HANDLE_EVENT = 'HANDLE_EVENT';
  Web3Event.RECEIVER_CONNECTED = 'RECEIVER_CONNECTED';
  Web3Event.RECEIVER_ERROR = 'RECEIVER_ERROR';
  Web3Event.RECEIVER_CLOSE = 'RECEIVER_CLOSE';
  Web3Event.RECEIVER_RECONNECT = 'RECEIVER_RECONNECT';
  Web3Event.HANDLE_ERROR = 'HANDLE_ERROR';
  return Web3Event;
}();

exports.Web3Event = Web3Event;

var ReceiverErrorCode =
/** @class */
function () {
  function ReceiverErrorCode() {}

  ReceiverErrorCode.MaxAttemptsReachedOnReconnectingError = 'Maximum number of reconnect attempts reached!';
  return ReceiverErrorCode;
}();

exports.ReceiverErrorCode = ReceiverErrorCode;

var Web3Role =
/** @class */
function () {
  function Web3Role() {}

  Web3Role.Sender = "Sender";
  Web3Role.Receiver = "Receiver";
  return Web3Role;
}();

exports.Web3Role = Web3Role;

/***/ }),

/***/ 868:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PollingEventManager = void 0;

var utils_1 = __webpack_require__(178);

var IWeb3Adapter_1 = __webpack_require__(556);

var PollingEventManager =
/** @class */
function () {
  function PollingEventManager(adapter, listener) {
    this.adapter = adapter;
    this.listener = listener;
    this.pollingMap = new utils_1.TSMap();
  }
  /**
   * 開始輪詢事件
   * @param contract 合約實體
   * @param method 合約事件
   * @param interval 輪詢間隔時間
   */


  PollingEventManager.prototype.startPollingEvent = function (contract, method, interval) {
    var _this = this;

    if (interval === void 0) {
      interval = 5000;
    }

    this.stopPollingEvent(method);
    this.adapter.getBlockNumber().then(function (blockNumber) {
      _this.pollingEvent(contract, method, blockNumber, interval);
    });
  };
  /**
   * 停止輪詢事件
   * @param method 合約事件
   * @return true, 成功停止事件取得的輪詢
   */


  PollingEventManager.prototype.stopPollingEvent = function (method) {
    var timeoutId = this.pollingMap.get(method);
    if (!timeoutId) return false;
    clearTimeout(timeoutId);
    this.pollingMap["delete"](method);
    return true;
  };

  PollingEventManager.prototype.pollingEvent = function (contract, method, from, interval) {
    var _this = this;

    var options = {
      fromBlock: from,
      toBlock: 'latest'
    };
    this.adapter.getPastEvents(contract, method, options, function (err, events) {
      if (!err) {
        _this.handleAllEvents(events);

        if (events.length > 0) from = events[events.length - 1].blockNumber + 1;
      }

      var timeoutId = setTimeout(function () {
        return __awaiter(_this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            this.pollingEvent(contract, method, from, interval);
            return [2
            /*return*/
            ];
          });
        });
      }, interval);

      _this.pollingMap.set(method, timeoutId);
    });
  };

  PollingEventManager.prototype.handleAllEvents = function (events) {
    var _this = this;

    if (!events) return;
    events.forEach(function (evt) {
      _this.listener.on(IWeb3Adapter_1.Web3Event.HANDLE_EVENT, evt);
    });
  };

  return PollingEventManager;
}();

exports.PollingEventManager = PollingEventManager;

/***/ }),

/***/ 289:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Web3Wallet = void 0;

var IWeb3Adapter_1 = __webpack_require__(556);

var TSMap_1 = __webpack_require__(645);

var Web3Wallet =
/** @class */
function () {
  function Web3Wallet(sender, receiver) {
    this.sender = sender;
    this.receiver = receiver;
    this.MAX_ERROR_COUNT = 1;
    this.MAX_RETRY_COUNT = 0;
    this.roleContractMap = new TSMap_1.TSMap();
    this.roleAdapterMap = new TSMap_1.TSMap();
    this.roleAdapterMap.set(IWeb3Adapter_1.Web3Role.Sender, sender);
    this.roleAdapterMap.set(IWeb3Adapter_1.Web3Role.Receiver, receiver);
    this.errorCount = 0;
    this.retryCount = 0;
    this.reconnectCount = 0;
    this.handleAdapterEvents();
  }
  /**
   * 設定主鏈參數
   * @param param
   */


  Web3Wallet.prototype.setChainParameter = function (param) {
    this.chainParam = param;
  };
  /**
   * 連結錢包
   */


  Web3Wallet.prototype.connect = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, rpcUrls, chainId, _b;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (!this.chainParam) throw new Error("Chain parameter is not exist");
            this.initListener();
            if (!this.sender.detectProvider() || !this.receiver.detectProvider()) return [2
            /*return*/
            , Web3Wallet.PROVIDER_NOT_EXIST];
            return [4
            /*yield*/
            , this.sender.isLogin()];

          case 1:
            _a = !_c.sent();
            if (_a) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , this.receiver.isLogin()];

          case 2:
            _a = !_c.sent();
            _c.label = 3;

          case 3:
            if (_a) this.dispatchEvent(Web3Wallet.NOT_CONNECTED);
            rpcUrls = this.chainParam.rpcUrls;
            if (!this.sender.checkRPCUrl(rpcUrls) || !this.receiver.checkRPCUrl(rpcUrls)) return [2
            /*return*/
            , Web3Wallet.NOT_SET_WS_RPC_URLS];
            return [4
            /*yield*/
            , this.sender.requestChain()];

          case 4:
            chainId = _c.sent();
            this.dispatchEvent(Web3Wallet.CHANGE_CHAIN, chainId);
            return [4
            /*yield*/
            , this.checkChainId(chainId)];

          case 5:
            _c.sent();

            return [4
            /*yield*/
            , this.sender.isConnected()];

          case 6:
            _b = !_c.sent();
            if (_b) return [3
            /*break*/
            , 8];
            return [4
            /*yield*/
            , this.receiver.isConnected()];

          case 7:
            _b = !_c.sent();
            _c.label = 8;

          case 8:
            if (_b) return [2
            /*return*/
            , Web3Wallet.ACCOUNTS_NOT_EXIST];
            this.initWeb3();
            return [2
            /*return*/
            , Web3Wallet.CONNECTED];
        }
      });
    });
  };

  Web3Wallet.prototype.initListener = function () {
    var _this = this;

    this.roleAdapterMap.forEach(function (adapter, role) {
      adapter.setListener(_this);
    });
  };

  Web3Wallet.prototype.initWeb3 = function () {
    var _this = this;

    this.changeRPCUrl();
    this.roleAdapterMap.forEach(function (adapter, role) {
      adapter.setRPCUrl(_this.curRPCUrl);
      adapter.initWeb3();
    });
  };

  Web3Wallet.prototype.checkChainId = function (chainId) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (chainId === this.chainParam.chainId) {
              return [2
              /*return*/
              ];
            }

            return [4
            /*yield*/
            , this.sender.switchChain(this.chainParam.chainId)["catch"](this.onCatchSwitchChain.bind(this))];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Web3Wallet.prototype.onCatchSwitchChain = function (err) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (err.code !== 4902) return [2
            /*return*/
            ];
            return [4
            /*yield*/
            , this.sender.addChain(this.chainParam)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * @param name
   * @param abi
   * @param address
   */


  Web3Wallet.prototype.setContract = function (name, abi, address) {
    this.createContract(name, abi, address, IWeb3Adapter_1.Web3Role.Sender);
    this.createContract(name, abi, address, IWeb3Adapter_1.Web3Role.Receiver);
  };

  Web3Wallet.prototype.createContract = function (name, abi, address, role) {
    var adapter = this.roleAdapterMap.get(role);
    var contractMap = this.roleContractMap.get(role);
    if (!contractMap) contractMap = new TSMap_1.TSMap();
    var contract = adapter.createContract(abi, address, role);
    if (!contract) throw new Error("Failed creating: ".concat(name, ", role: ").concat(role));
    contractMap.set(name, contract);
    this.roleContractMap.set(role, contractMap);
  };

  Web3Wallet.prototype.getContract = function (contractName, role) {
    var contractMap = this.roleContractMap.get(role);
    if (!contractMap) return undefined;
    return contractMap.get(contractName);
  };
  /**
   * 取得錢包的帳號位址
   */


  Web3Wallet.prototype.getAccounts = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.sender.getAccounts()];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };
  /**
   * @return true 已經連結到錢包
   */


  Web3Wallet.prototype.isConnected = function () {
    return __awaiter(this, void 0, void 0, function () {
      var accounts;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.sender.getAccounts()];

          case 1:
            accounts = _a.sent();
            return [2
            /*return*/
            , accounts && accounts.length > 0];
        }
      });
    });
  };

  Web3Wallet.prototype.setListener = function (listener) {
    this.listener = listener;
  };

  Web3Wallet.prototype.on = function (evt, obj) {
    var fn = this.eventMap.get(evt);

    if (!fn) {
      console.warn("event ".concat(evt, " not define"));
      return;
    }

    fn(obj);
  };

  Web3Wallet.prototype.dispatchEvent = function (evt, obj) {
    if (!this.listener) return;
    this.listener.on(evt, obj);
  };
  /**
   * 取得指定帳號下的餘額
   * @param account
   */


  Web3Wallet.prototype.getBalance = function (account) {
    return __awaiter(this, void 0, void 0, function () {
      var balance;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.sender.getBalance(account)];

          case 1:
            balance = _a.sent();
            return [2
            /*return*/
            , balance === undefined ? "0" : balance];
        }
      });
    });
  };
  /**
   * 取得當前的區塊數字
   * @return 區塊數字
   */


  Web3Wallet.prototype.getBlockNumber = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.sender.getBlockNumber()];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };
  /**
   * 取得指定交易hash的交易物件
   * @param hash
   * @return 交易物件
   */


  Web3Wallet.prototype.getTransaction = function (hash) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.sender.getTransaction(hash)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };
  /**
   * 取得指定交易hash的收據
   * @param hash
   * @return 收據物件
   */


  Web3Wallet.prototype.getTransactionReceipt = function (hash) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.sender.getTransactionReceipt(hash)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  Web3Wallet.prototype.registerEvent = function (contractName, method, options) {
    if (options === void 0) {
      options = {};
    }

    var contract = this.getContract(contractName, IWeb3Adapter_1.Web3Role.Receiver);
    if (!contract) return false;
    var adapter = this.roleAdapterMap.get(IWeb3Adapter_1.Web3Role.Receiver);
    adapter.registerEvent(contract, method, options);
    return true;
  };

  Web3Wallet.prototype.handleEvent = function (evt) {
    var evtName = evt.event;
    this.dispatchEvent(evtName, evt);
  };

  Web3Wallet.prototype.handleError = function (err) {
    this.dispatchEvent(Web3Wallet.EV_RESPONSE_ERROR, err);
  };

  Web3Wallet.prototype.registerAllEvents = function (contractName, options) {
    if (options === void 0) {
      options = {};
    }

    return this.registerEvent(contractName, 'allEvents', options);
  };

  Web3Wallet.prototype.getPastEvents = function (contractName, method, options, callback) {
    var contract = this.getContract(contractName, IWeb3Adapter_1.Web3Role.Receiver);
    if (!contract) return false;
    var adapter = this.roleAdapterMap.get(IWeb3Adapter_1.Web3Role.Receiver);
    adapter.getPastEvents(contract, method, options, callback);
    return true;
  };
  /**
   * 傳送需求到合約
   * @param req
   * @return true, send to the contract
   */


  Web3Wallet.prototype.send = function (req) {
    var role = req.getRole();
    var name = req.getName();
    var contract = this.getContract(name, role);
    if (!contract) return false;
    req.send(contract);
    return true;
  };

  Web3Wallet.prototype.handleAdapterEvents = function () {
    this.eventMap = new TSMap_1.TSMap();
    this.eventMap.set(IWeb3Adapter_1.Web3Event.RECEIVER_CONNECTED, this.onReceiverConnect.bind(this));
    this.eventMap.set(IWeb3Adapter_1.Web3Event.RECEIVER_ERROR, this.onReceiverError.bind(this));
    this.eventMap.set(IWeb3Adapter_1.Web3Event.RECEIVER_CLOSE, this.onReceiverClose.bind(this));
    this.eventMap.set(IWeb3Adapter_1.Web3Event.HANDLE_EVENT, this.handleEvent.bind(this));
    this.eventMap.set(IWeb3Adapter_1.Web3Event.HANDLE_ERROR, this.handleError.bind(this));
    this.eventMap.set(IWeb3Adapter_1.Web3Event.CHANGE_CHAIN, this.onChangeChain.bind(this));
    this.eventMap.set(IWeb3Adapter_1.Web3Event.CHANGE_ACCOUNT, this.onChangeAccount.bind(this));
    this.eventMap.set(IWeb3Adapter_1.Web3Event.RECEIVER_RECONNECT, this.onReceiverReconnect.bind(this));
  };

  Web3Wallet.prototype.onReceiverConnect = function () {
    this.errorCount = 0;
    this.retryCount = 0;
    var contractMap = this.roleContractMap.get(IWeb3Adapter_1.Web3Role.Receiver);

    if (contractMap) {
      var adapter = this.roleAdapterMap.get(IWeb3Adapter_1.Web3Role.Receiver);
      var provider_1 = adapter.getProvider();
      contractMap.forEach(function (value) {
        value.setProvider(provider_1);
      });
    }

    var isReconnect = this.reconnectCount > 0;
    this.dispatchEvent(Web3Wallet.RECEIVER_CONNECTED, isReconnect);
    this.reconnectCount = 0;
  };

  Web3Wallet.prototype.onReceiverError = function (error) {
    this.errorCount++;
    var adapter = this.roleAdapterMap.get(IWeb3Adapter_1.Web3Role.Receiver);

    if (this.isFatalError(error)) {
      this.reconnectCount = 0;
      this.changeRPCUrl();
      adapter.setRPCUrl(this.curRPCUrl);
      adapter.initWeb3();
      this.errorCount = 0;
    } else if (this.errorCount >= this.MAX_ERROR_COUNT) {
      adapter.disconnect();
      this.errorCount = 0;
    }
  };

  Web3Wallet.prototype.isFatalError = function (error) {
    if (error && error.message) {
      return error.message == IWeb3Adapter_1.ReceiverErrorCode.MaxAttemptsReachedOnReconnectingError;
    }

    return false;
  };

  Web3Wallet.prototype.onReceiverClose = function () {
    var adapter = this.roleAdapterMap.get(IWeb3Adapter_1.Web3Role.Receiver);
    this.retryCount++;

    if (this.retryCount >= this.MAX_RETRY_COUNT) {
      this.changeRPCUrl();
      adapter.setRPCUrl(this.curRPCUrl);
      adapter.initWeb3();
      this.retryCount = 0;
    } else {
      adapter.connect();
    }

    this.dispatchEvent(Web3Wallet.RECEIVER_CONNECTING);
  };

  Web3Wallet.prototype.onReceiverReconnect = function (count) {
    this.reconnectCount = count;
    this.dispatchEvent(Web3Wallet.RECEIVER_CONNECTING, count);
  };

  Web3Wallet.prototype.getWSUrls = function () {
    if (!this.chainParam.rpcUrls) return undefined;
    var wsUrls = this.chainParam.rpcUrls.filter(function (url) {
      return url.indexOf("wss") > -1;
    });
    return wsUrls;
  };

  Web3Wallet.prototype.changeRPCUrl = function () {
    var wsRPCUrls = this.getWSUrls();
    if (!wsRPCUrls || wsRPCUrls.length < 1) return;
    var curIndex = wsRPCUrls.indexOf(this.curRPCUrl);
    var newIndex = curIndex == wsRPCUrls.length - 1 ? 0 : ++curIndex;
    this.curRPCUrl = newIndex >= wsRPCUrls.length ? wsRPCUrls[0] : wsRPCUrls[newIndex];
  };

  Web3Wallet.prototype.onChangeChain = function (chainId) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.dispatchEvent(Web3Wallet.CHANGE_CHAIN, chainId);
            return [4
            /*yield*/
            , this.checkChainId(chainId)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Web3Wallet.prototype.onChangeAccount = function (accounts) {
    this.dispatchEvent(Web3Wallet.CHANGE_ACCOUNT, accounts);
  };
  /**
   * 輪詢balance
   * @param address   監看的地址
   * @param interval  輪詢間隔
   * @param timeout   輪詢時間
   * @param callback  回傳取得的balance
   * @return bool 是否正在輪詢balance
   */


  Web3Wallet.prototype.watchBalance = function (address, interval, timeout, callback) {
    var _this = this;

    if (this.watchInterval) return true;
    this.watchInterval = setInterval(function () {
      _this.getBalance(address).then(function (balance) {
        callback(balance);
      });
    }, interval);
    this.watchTimeout = setTimeout(function () {
      _this.clearWatchInterval();

      _this.watchTimeout = undefined;
    }, timeout);
    return false;
  };
  /**
   * 停止輪詢balance
   */


  Web3Wallet.prototype.stopWatchBalance = function () {
    this.clearWatchInterval();

    if (this.watchTimeout) {
      clearTimeout(this.watchTimeout);
      this.watchTimeout = undefined;
    }
  };

  Web3Wallet.prototype.clearWatchInterval = function () {
    if (this.watchInterval) {
      clearInterval(this.watchInterval);
      this.watchInterval = undefined;
    }
  };

  Web3Wallet.CONNECTED = 'CONNECTED';
  Web3Wallet.NOT_CONNECTED = 'NOT_CONNECTED';
  Web3Wallet.PROVIDER_NOT_EXIST = 'PROVIDER_NOT_EXIST';
  Web3Wallet.ACCOUNTS_NOT_EXIST = 'ACCOUNTS_NOT_EXIST';
  Web3Wallet.NOT_SET_WS_RPC_URLS = 'NOT_SET_WS_RPC_URLS';
  Web3Wallet.EV_WEB3_ERROR = 'EV_WEB3_ERROR';
  Web3Wallet.EV_RESPONSE_ERROR = 'EV_RESPONSE_ERROR';
  Web3Wallet.RECEIVER_CONNECTED = 'RECEIVER_CONNECTED';
  Web3Wallet.RECEIVER_CONNECTING = 'RECEIVER_CONNECTING';
  Web3Wallet.CHANGE_CHAIN = IWeb3Adapter_1.Web3Event.CHANGE_CHAIN;
  Web3Wallet.CHANGE_ACCOUNT = IWeb3Adapter_1.Web3Event.CHANGE_ACCOUNT;
  return Web3Wallet;
}();

exports.Web3Wallet = Web3Wallet;

/***/ }),

/***/ 109:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MetaMask = void 0;

var IWeb3Adapter_1 = __webpack_require__(556);

var PollingEventManager_1 = __webpack_require__(868);

var Web3 = window['Web3'];
var Ethereum = window['ethereum'];

var MetaMask =
/** @class */
function () {
  function MetaMask() {}

  MetaMask.prototype.detectProvider = function () {
    return Ethereum;
  };

  MetaMask.prototype.initWeb3 = function () {
    Ethereum.on('accountsChanged', this.on.bind(this, IWeb3Adapter_1.Web3Event.CHANGE_ACCOUNT));
    Ethereum.on('chainChanged', this.on.bind(this, IWeb3Adapter_1.Web3Event.CHANGE_CHAIN));
    this.web3 = new Web3(Ethereum);
    this.pollingEventManager = new PollingEventManager_1.PollingEventManager(this, this.listener);
  };

  MetaMask.prototype.requestAccounts = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        return [2
        /*return*/
        , Ethereum.request({
          method: 'eth_requestAccounts'
        }).then(function (account) {
          _this.on(IWeb3Adapter_1.Web3Event.CHANGE_ACCOUNT, account);

          return account;
        })["catch"](function (err) {
          return err;
        })];
      });
    });
  };

  MetaMask.prototype.setListener = function (listener) {
    this.listener = listener;
  };

  MetaMask.prototype.on = function (evt, obj) {
    if (!this.listener) return;
    this.listener.on.call(this.listener, evt, obj);
  };

  MetaMask.prototype.requestChain = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , Ethereum.request({
              method: 'eth_chainId'
            })];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  MetaMask.prototype.getAccounts = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , Ethereum.request({
              method: 'eth_accounts'
            })];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  MetaMask.prototype.switchChain = function (chainId) {
    return new Promise(function (resolve, reject) {
      return __awaiter(this, void 0, void 0, function () {
        var res, error_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2,, 3]);

              return [4
              /*yield*/
              , Ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{
                  chainId: chainId
                }]
              })];

            case 1:
              res = _a.sent();
              resolve(res);
              return [3
              /*break*/
              , 3];

            case 2:
              error_1 = _a.sent();
              reject(error_1);
              return [3
              /*break*/
              , 3];

            case 3:
              return [2
              /*return*/
              ];
          }
        });
      });
    });
  };

  MetaMask.prototype.addChain = function (params) {
    return new Promise(function (resolve, reject) {
      return __awaiter(this, void 0, void 0, function () {
        var res, error_2;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2,, 3]);

              return [4
              /*yield*/
              , Ethereum.request({
                method: 'wallet_addEthereumChain',
                params: [params]
              })];

            case 1:
              res = _a.sent();
              resolve(res);
              return [3
              /*break*/
              , 3];

            case 2:
              error_2 = _a.sent();
              reject(error_2);
              return [3
              /*break*/
              , 3];

            case 3:
              return [2
              /*return*/
              ];
          }
        });
      });
    });
  };

  MetaMask.prototype.createContract = function (abi, address, role) {
    var contract = new this.web3.eth.Contract(abi, address);
    return contract;
  };

  MetaMask.prototype.getBalance = function (account) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.web3.eth.getBalance(account)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  MetaMask.prototype.getBlockNumber = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.web3.eth.getBlockNumber()];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  MetaMask.prototype.getTransaction = function (hash) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.web3.eth.getTransaction(hash)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  MetaMask.prototype.getTransactionReceipt = function (hash) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.web3.eth.getTransactionReceipt(hash)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  MetaMask.prototype.setRPCUrl = function (rpcUrl) {};

  MetaMask.prototype.connect = function () {};

  MetaMask.prototype.disconnect = function () {};

  MetaMask.prototype.getProvider = function () {
    if (this.web3) {
      return this.web3.currentProvider;
    }
  };

  MetaMask.prototype.getPastEvents = function (contract, method, options, callback) {
    contract.getPastEvents(method, options, callback);
  };

  MetaMask.prototype.registerEvent = function (contract, method, options) {
    this.pollingEventManager.startPollingEvent(contract, method, options.interval | 5000);
  };

  MetaMask.prototype.checkRPCUrl = function (rpcUrls) {
    return true;
  };

  MetaMask.prototype.isConnected = function () {
    return __awaiter(this, void 0, void 0, function () {
      var accountList;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.requestAccounts()];

          case 1:
            accountList = _a.sent();
            return [2
            /*return*/
            , accountList && accountList.length > 0];
        }
      });
    });
  };

  MetaMask.prototype.isLogin = function () {
    return __awaiter(this, void 0, void 0, function () {
      var accounts;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.getAccounts()];

          case 1:
            accounts = _a.sent();
            return [2
            /*return*/
            , accounts && accounts.length > 0];
        }
      });
    });
  };

  return MetaMask;
}();

exports.MetaMask = MetaMask;

/***/ }),

/***/ 687:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.WebsocketProvider = void 0;

var IWeb3Adapter_1 = __webpack_require__(556);

var Web3 = window['Web3'];

var WebsocketProvider =
/** @class */
function () {
  function WebsocketProvider(option) {
    this.option = option;
  }

  WebsocketProvider.prototype.detectProvider = function () {
    return true;
  };

  WebsocketProvider.prototype.initWeb3 = function () {
    this.unregisterProviderEvent();
    this.provider = new Web3.providers.WebsocketProvider(this.rpcUrl, this.option);
    this.web3 = new Web3(this.provider);
    this.registerProviderEvent();
  };

  WebsocketProvider.prototype.registerProviderEvent = function () {
    var provider = this.getProvider();
    if (!provider) return;
    provider.on('connect', this.onReceiverConnect.bind(this));
    provider.on('error', this.onReceiverError.bind(this));
    provider.on('close', this.onReceiverClose.bind(this));
    provider.on('reconnect', this.onReceiverReconnect.bind(this));
  };

  WebsocketProvider.prototype.unregisterProviderEvent = function () {
    var provider = this.getProvider();
    if (!provider) return;
    provider.off('connect', this.onReceiverConnect.bind(this));
    provider.off('error', this.onReceiverError.bind(this));
    provider.off('close', this.onReceiverClose.bind(this));
    provider.off('reconnect', this.onReceiverReconnect.bind(this));
  };

  WebsocketProvider.prototype.onReceiverConnect = function () {
    this.on(IWeb3Adapter_1.Web3Event.RECEIVER_CONNECTED);
  };

  WebsocketProvider.prototype.onReceiverError = function (error) {
    console.error("Receiver error", error);
    this.on(IWeb3Adapter_1.Web3Event.RECEIVER_ERROR, error);
  };

  WebsocketProvider.prototype.onReceiverClose = function (event) {
    console.error("Receiver close", event);
    this.on(IWeb3Adapter_1.Web3Event.RECEIVER_CLOSE, event);
  };

  WebsocketProvider.prototype.onReceiverReconnect = function (count) {
    console.warn("Receiver reconnect", count);
    this.on(IWeb3Adapter_1.Web3Event.RECEIVER_RECONNECT, count);
  };

  WebsocketProvider.prototype.requestAccounts = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.web3.eth.getAccounts()];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  WebsocketProvider.prototype.setListener = function (listener) {
    this.listener = listener;
  };

  WebsocketProvider.prototype.on = function (evt, obj) {
    if (!this.listener) return;
    this.listener.on.call(this.listener, evt, obj);
  };

  WebsocketProvider.prototype.requestChain = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.web3.eth.getChainId()];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  WebsocketProvider.prototype.getAccounts = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.web3.eth.getAccounts()];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  WebsocketProvider.prototype.switchChain = function (chainId) {
    return;
  };

  WebsocketProvider.prototype.addChain = function (params) {};

  WebsocketProvider.prototype.createContract = function (abi, address, role) {
    var contract = new this.web3.eth.Contract(abi, address);
    return contract;
  };

  WebsocketProvider.prototype.getBalance = function (account) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.web3.eth.getBalance(account)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  WebsocketProvider.prototype.getBlockNumber = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.web3.eth.getBlockNumber()];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  WebsocketProvider.prototype.getTransaction = function (hash) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.web3.eth.getTransaction(hash)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  WebsocketProvider.prototype.getTransactionReceipt = function (hash) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.web3.eth.getTransactionReceipt(hash)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  WebsocketProvider.prototype.setRPCUrl = function (rpcUrl) {
    this.rpcUrl = rpcUrl;
  };

  WebsocketProvider.prototype.connect = function () {
    var provider = this.getProvider();

    if (!provider) {
      return;
    }

    provider.connect();
    this.registerProviderEvent();
  };

  WebsocketProvider.prototype.disconnect = function () {
    var provider = this.getProvider();

    if (!provider) {
      return;
    }

    if (provider.connected) provider.disconnect();
    this.unregisterProviderEvent();
  };

  WebsocketProvider.prototype.getProvider = function () {
    return this.provider;
  };

  WebsocketProvider.prototype.getPastEvents = function (contract, method, options, callback) {
    contract.getPastEvents(method, options, callback);
  };

  WebsocketProvider.prototype.handelEvent = function (err, evt) {
    if (err) {
      this.on(IWeb3Adapter_1.Web3Event.HANDLE_ERROR, err);
      return;
    }

    this.on(IWeb3Adapter_1.Web3Event.HANDLE_EVENT, evt);
  };

  WebsocketProvider.prototype.registerEvent = function (contract, method, options) {
    contract.events[method](options, this.handelEvent.bind(this));
  };

  WebsocketProvider.prototype.checkRPCUrl = function (rpcUrls) {
    if (!rpcUrls) return false;
    var wsUrls = rpcUrls.filter(function (url) {
      return url.indexOf("wss") > -1;
    });
    return wsUrls && wsUrls.length > 0;
  };

  WebsocketProvider.prototype.isConnected = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , true];
      });
    });
  };

  WebsocketProvider.prototype.isLogin = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , true];
      });
    });
  };

  return WebsocketProvider;
}();

exports.WebsocketProvider = WebsocketProvider;

/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));

__exportStar(__webpack_require__(109), exports);

__exportStar(__webpack_require__(687), exports);

/***/ }),

/***/ 56:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));

__exportStar(__webpack_require__(579), exports);

__exportStar(__webpack_require__(178), exports);

__exportStar(__webpack_require__(480), exports);

__exportStar(__webpack_require__(860), exports);

__exportStar(__webpack_require__(414), exports);

__exportStar(__webpack_require__(895), exports);

__exportStar(__webpack_require__(676), exports);

__exportStar(__webpack_require__(556), exports);

__exportStar(__webpack_require__(868), exports);

__exportStar(__webpack_require__(289), exports);

/***/ }),

/***/ 645:
/***/ ((__unused_webpack_module, exports) => {



function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TSMap = void 0;
/**
 * @author https://www.npmjs.com/package/typescript-map
 */

var TSMap =
/** @class */
function () {
  function TSMap(inputMap) {
    var t = this;
    t._keys = [];
    t._values = [];
    t.length = 0;

    if (inputMap) {
      inputMap.forEach(function (v, k) {
        t.set(v[0], v[1]);
      });
    }
  }
  /**
   * Convert a JSON object to a map.
   *
   * @param {*} jsonObject JSON object to convert
   * @param {boolean} [convertObjs] convert nested objects to maps
   * @returns {TSMap<K, V>}
   * @memberof TSMap
   */


  TSMap.prototype.fromJSON = function (jsonObject, convertObjs) {
    var t = this;

    var setProperty = function setProperty(value) {
      if (value !== null && _typeof(value) === 'object' && convertObjs) return new TSMap().fromJSON(value, true);
      if (Array.isArray(value) && convertObjs) return value.map(function (v) {
        return setProperty(v);
      });
      return value;
    };

    Object.keys(jsonObject).forEach(function (property) {
      if (jsonObject.hasOwnProperty(property)) {
        t.set(property, setProperty(jsonObject[property]));
      }
    });
    return t;
  };
  /**
   * Outputs the contents of the map to a JSON object
   *
   * @returns {{[key: string]: V}}
   * @memberof TSMap
   */


  TSMap.prototype.toJSON = function () {
    var obj = {};
    var t = this;

    var getValue = function getValue(value) {
      if (value instanceof TSMap) {
        return value.toJSON();
      } else if (Array.isArray(value)) {
        return value.map(function (v) {
          return getValue(v);
        });
      } else {
        return value;
      }
    };

    t.keys().forEach(function (k) {
      obj[String(k)] = getValue(t.get(k));
    });
    return obj;
  };
  /**
   * Get an array of arrays respresenting the map, kind of like an export function.
   *
   * @returns {(Array<Array<K|V>>)}
   *
   * @memberOf TSMap
   */


  TSMap.prototype.entries = function () {
    var _this = this;

    return [].slice.call(this.keys().map(function (k) {
      return [k, _this.get(k)];
    }));
  };
  /**
   * Get an array of keys in the map.
   *
   * @returns {Array<K>}
   *
   * @memberOf TSMap
   */


  TSMap.prototype.keys = function () {
    return [].slice.call(this._keys);
  };
  /**
   * Get an array of the values in the map.
   *
   * @returns {Array<V>}
   *
   * @memberOf TSMap
   */


  TSMap.prototype.values = function () {
    return [].slice.call(this._values);
  };
  /**
   * Check to see if an item in the map exists given it's key.
   *
   * @param {K} key
   * @returns {Boolean}
   *
   * @memberOf TSMap
   */


  TSMap.prototype.has = function (key) {
    return this._keys.indexOf(key) > -1;
  };
  /**
   * Get a specific item from the map given it's key.
   *
   * @param {K} key
   * @returns {V}
   *
   * @memberOf TSMap
   */


  TSMap.prototype.get = function (key) {
    var i = this._keys.indexOf(key);

    return i > -1 ? this._values[i] : undefined;
  };
  /**
   * Safely retrieve a deeply nested property.
   *
   * @param {K[]} path
   * @returns {V}
   *
   * @memberOf TSMap
   */


  TSMap.prototype.deepGet = function (path) {
    if (!path || !path.length) return null;

    var recursiveGet = function recursiveGet(obj, path) {
      if (obj === undefined || obj === null) return null;
      if (!path.length) return obj;
      return recursiveGet(obj instanceof TSMap ? obj.get(path[0]) : obj[path[0]], path.slice(1));
    };

    return recursiveGet(this.get(path[0]), path.slice(1));
  };
  /**
   * Set a specific item in the map given it's key, automatically adds new items as needed.
   * Ovewrrites existing items
   *
   * @param {K} key
   * @param {V} value
   *
   * @memberOf TSMap
   */


  TSMap.prototype.set = function (key, value) {
    var t = this; // check if key exists and overwrite

    var i = this._keys.indexOf(key);

    if (i > -1) {
      t._values[i] = value;
    } else {
      t._keys.push(key);

      t._values.push(value);

      t.length = t._values.length;
    }

    return this;
  };
  /**
   * Enters a value into the map forcing the keys to always be sorted.
   * Stolen from https://machinesaredigging.com/2014/04/27/binary-insert-how-to-keep-an-array-sorted-as-you-insert-data-in-it/
   * Best case speed is O(1), worse case is O(N).
   *
   * @param {K} key
   * @param {V} value
   * @param {number} [startVal]
   * @param {number} [endVal]
   * @returns {this}
   * @memberof TSMap
   */


  TSMap.prototype.sortedSet = function (key, value, startVal, endVal) {
    var t = this;
    var length = this._keys.length;
    var start = startVal || 0;
    var end = endVal !== undefined ? endVal : length - 1;

    if (length == 0) {
      t._keys.push(key);

      t._values.push(value);

      return t;
    }

    if (key == this._keys[start]) {
      this._values.splice(start, 0, value);

      return this;
    }

    if (key == this._keys[end]) {
      this._values.splice(end, 0, value);

      return this;
    }

    if (key > this._keys[end]) {
      this._keys.splice(end + 1, 0, key);

      this._values.splice(end + 1, 0, value);

      return this;
    }

    if (key < this._keys[start]) {
      this._values.splice(start, 0, value);

      this._keys.splice(start, 0, key);

      return this;
    }

    if (start >= end) {
      return this;
    }

    var m = start + Math.floor((end - start) / 2);

    if (key < this._keys[m]) {
      return this.sortedSet(key, value, start, m - 1);
    }

    if (key > this._keys[m]) {
      return this.sortedSet(key, value, m + 1, end);
    }

    return this;
  };
  /**
   * Provide a number representing the number of items in the map
   *
   * @returns {number}
   *
   * @memberOf TSMap
   */


  TSMap.prototype.size = function () {
    return this.length;
  };
  /**
   * Clear all the contents of the map
   *
   * @returns {TSMap<K,V>}
   *
   * @memberOf TSMap
   */


  TSMap.prototype.clear = function () {
    var t = this;
    t._keys.length = t.length = t._values.length = 0;
    return this;
  };
  /**
   * Delete an item from the map given it's key
   *
   * @param {K} key
   * @returns {Boolean}
   *
   * @memberOf TSMap
   */


  TSMap.prototype["delete"] = function (key) {
    var t = this;

    var i = t._keys.indexOf(key);

    if (i > -1) {
      t._keys.splice(i, 1);

      t._values.splice(i, 1);

      t.length = t._keys.length;
      return true;
    }

    return false;
  };
  /**
   * Used to loop through the map.
   *
   * @param {(value:V,key?:K,index?:number) => void} callbackfn
   *
   * @memberOf TSMap
   */


  TSMap.prototype.forEach = function (callbackfn) {
    var _this = this;

    this._keys.forEach(function (v, i) {
      callbackfn(_this.get(v), v, i);
    });
  };
  /**
   * Returns an array containing the returned value of each item in the map.
   *
   * @param {(value:V,key?:K,index?:number) => any} callbackfn
   * @returns {Array<any>}
   *
   * @memberOf TSMap
   */


  TSMap.prototype.map = function (callbackfn) {
    var _this = this;

    return this.keys().map(function (itemKey, i) {
      return callbackfn(_this.get(itemKey), itemKey, i);
    });
  };
  /**
   * Removes items based on a conditional function passed to filter.
   * Mutates the map in place.
   *
   * @param {(value:V,key?:K,index?:number) => Boolean} callbackfn
   * @returns {TSMap<K,V>}
   *
   * @memberOf TSMap
   */


  TSMap.prototype.filter = function (callbackfn) {
    var t = this;

    t._keys.forEach(function (v, i) {
      if (callbackfn(t.get(v), v, i) === false) t["delete"](v);
    });

    return this;
  };
  /**
   * Creates a deep copy of the map, breaking all references to the old map and it's children.
   * Uses JSON.parse so any functions will be stringified and lose their original purpose.
   *
   * @returns {TSMap<K,V>}
   *
   * @memberOf TSMap
   */


  TSMap.prototype.clone = function () {
    return new TSMap(this.entries());
  };

  return TSMap;
}();

exports.TSMap = TSMap;

/***/ }),

/***/ 178:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", ({
  value: true
}));

__exportStar(__webpack_require__(645), exports);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(56);
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});